import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { baseButton } from '../BaseComponents.css';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';
import * as styles from './Phone.css';
import type { SupportedCountryType } from './utils';

export interface PhoneTriggerProps extends React.ComponentPropsWithoutRef<'button'> {
  readonly isOpen: boolean;
  readonly country: SupportedCountryType;
  readonly isSingleCountry: boolean;
  readonly disabled?: boolean;
  readonly hasError?: boolean;
}

export const PhoneTrigger = forwardRef<HTMLButtonElement, PhoneTriggerProps>(
  ({ onClick, isOpen, country, isSingleCountry, disabled, hasError, ...props }, ref) => {
    return (
      <button
        className={clsx(
          baseButton,
          styles.phoneTriggerCta({
            // @ts-expect-error - TODO: fix recipes return type
            hasError,
            // @ts-expect-error - TODO: fix recipes return type
            disabled,
          }),
          {
            active: isOpen,
            [styles.singleCountryPhoneTrigger]: isSingleCountry,
          },
        )}
        disabled={disabled}
        onClick={onClick}
        ref={ref}
        type="button"
        {...props}
      >
        <Text type="h4">{country.flag}</Text>
        {!isSingleCountry && <Icon className={styles.caretIcon} name="dropdown" size="md" variant="secondary" />}
      </button>
    );
  },
);
